import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import {BLOCKS, INLINES} from "@contentful/rich-text-types";
import React from "react";
import {documentToReactComponents} from "@contentful/rich-text-react-renderer";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    richTextH3: {
        "& + $richTextH4": {
            paddingTop: theme.spacing(0)
        },
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        color: theme.palette.grey[900]
    },
    richTextH4: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
        color: theme.palette.grey[900]
    },
    richTextH5: {
        paddingBottom: theme.spacing(2),
        color: theme.palette.grey[900]
    },
    richTextP: {
        paddingBottom: theme.spacing(1)
    },
    richTextLink: {
        color: theme.palette.black,
        fontWeight: "500",
        cursor: "pointer",
        textDecoration: "underline",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        "&:hover": {
            textDecoration: "underline"
        },
    }
}));


const LegalRichText = ({jsonToConvert}) => {

    const classes = useStyles();
    // eslint-disable-next-line react/prop-types
    const RichTextTypography = ({children, variant, className, node}) => {
        return (
            <Typography
                className={className}
                variant={variant}
                // eslint-disable-next-line react/prop-types
                id={variant === "h3" ? node?.content[0].value : null}
            >
                {children}
            </Typography>
        );
    };

    // eslint-disable-next-line react/prop-types
    const RichTextLink = ({children, node}) => {
        return (
            <a
                // eslint-disable-next-line react/prop-types
                href={node?.data.uri}
                className={classes.richTextLink}
            >
                {children}
            </a>
        );
    };

    const options = {
        renderMark: {},
        renderNode: {
            // eslint-disable-next-line react/display-name
            [BLOCKS.HEADING_3]: (node, children) => (
                <RichTextTypography
                    className={classes.richTextH3}
                    variant={"h3"}
                    node={node}
                >{children}</RichTextTypography>
            ),
            // eslint-disable-next-line react/display-name
            [BLOCKS.HEADING_4]: (node, children) => (
                <RichTextTypography
                    className={classes.richTextH4}
                    variant={"h4"}
                    node={node}
                >{children}</RichTextTypography>
            ),
            // eslint-disable-next-line react/display-name
            [BLOCKS.HEADING_5]: (node, children) => (
                <RichTextTypography
                    className={classes.richTextH5}
                    variant={"h5"}
                    node={node}
                >{children}</RichTextTypography>
            ),
            // eslint-disable-next-line react/display-name
            [BLOCKS.PARAGRAPH]: (node, children) => (
                <RichTextTypography
                    className={classes.richTextP}
                    variant={"body1"}
                    node={node}
                >{children}</RichTextTypography>
            ),
            // eslint-disable-next-line react/display-name
            [INLINES.HYPERLINK]: (node, children) => (
                <RichTextLink
                    node={node}
                    variant={"h3"}
                >{children}</RichTextLink>
            )
        },

    };

    return (documentToReactComponents(jsonToConvert, options)) ;

};

LegalRichText.propTypes = {
    jsonToConvert: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ])
};

export default LegalRichText;
